import * as yup from 'yup';

import { FilterOption } from 'features/creators/components/molecules/CreatorSearch';
import { buttonGroupSchema } from 'shared/components/molecules/ButtonGroupInput/validation';
import { ValueAccessorMap, ValueAccessorMethods } from 'shared/components/molecules/FilterForm/FilterForm';

const schema = yup.object({
  search: yup.string(),
  industry: buttonGroupSchema,
});

const multiSelectButtonGroupAccessors: (prefix?: string, onlyOther?: boolean) => ValueAccessorMethods = (
  prefix = '',
  onlyOther: boolean = false,
) => ({
  getDisplay: (val: FilterOption[]): string[] => {
    return val
      .filter((option) => option.selected)
      .map(({ label }) => {
        if (onlyOther) return label === 'Other' ? `${prefix}${label}` : label;
        else {
          return `${prefix}${label}`;
        }
      });
  },
  resetValue: (display: string, initialValue: FilterOption[], values: FilterOption[]) => {
    return initialValue.map((val) => {
      const displayLabel = prefix ? display.replace(prefix, '') : display;
      if (val.label === displayLabel) {
        return initialValue.find((v) => v.label === displayLabel);
      }
      return values.find((v) => v.label === val.label);
    });
  },
});

export const valueAccessorMap: ValueAccessorMap = {
  industry: multiSelectButtonGroupAccessors(),
};

export default schema;
